<template>
	<TabView class="h-100" :activeIndex.sync="activeTab">
		<TabPanel class="h-100">
			<template #header>
				<font-awesome-icon icon="pen" class="mr-1" />
				<span>{{ $t('notes.draw') }}</span>
			</template>
			<NotesDraw v-if="activeTab === 0" />
		</TabPanel>
		<TabPanel class="h-100">
			<template #header>
				<font-awesome-icon icon="sticky-note" class="mr-1" />
				<span>{{ $t('notes.write') }}</span>
			</template>
			<NotesList />
		</TabPanel>
	</TabView>
</template>

<script>
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import NotesList from "@/components/notes/NotesList.vue";
import NotesDraw from "@/components/notes/NotesDraw.vue";

export default {
	name: 'NoteListView',
	components: {
		NotesDraw,
		TabView,
		TabPanel,
		NotesList
	},
	data() {
		return {
			activeTab: 0,
		}
	}
}
</script>

<style>
.p-tabview-nav-content {
	height: 83px;
}
.p-tabview-nav-link {
	height: stretch;
}
.p-tabview-nav-link:hover {
	text-decoration: none;
}
.p-tabview-panels {
	height: calc(100% - 68px);
	padding-left: 0 !important;
	padding-right: 0 !important;
}
.p-tabview-nav > li {
	width: 100%;
}
</style>
